import React, { useContext } from "react";
import i18next from "i18next";
import { Select } from "antd";
import { LanguageContext } from "../../../context/LanguageProvider";
import { DropDownCloseIcon } from "../../../assets/svg";
import { languageData } from "../../../constants/data";

const LanguageDropdown = ({height, width}) => {
  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext);
  // function -> language change
  const handleChange = (value) => {
    const updatedLanguageData = Object.keys(languageData)?.map((item) => {
      if (item === value) {
        return { ...languageData[item], active: true };
      } else {
        return { ...languageData[item], active: false };
      }
    });
    const activeLanguage = updatedLanguageData?.filter((item) => item?.active);
    i18next.changeLanguage(value);
    setSelectedLanguage(activeLanguage[0]);
    document.body.dir = languageData[value].dir;
  };

  return (
    <>
      <Select
        suffixIcon={<DropDownCloseIcon width={width} height={height} />}
        popupMatchSelectWidth={true}
        defaultValue={selectedLanguage}
        style={{ width: 70 }}
        onChange={handleChange}
      >
        {Object.keys(languageData)?.map((item, i) => (
          <Select.Option key={i} value={languageData[item]?.value}>
            {languageData[item]?.label}
          </Select.Option>
        ))}
      </Select>
    </>
  );
};

export default LanguageDropdown;
